import { Grid } from "@material-ui/core";
import { useQuoteField } from "Quoting/components/hooks/useHandleQuoteFieldChange";
import React from "react";
import { useSelector } from "react-redux";
import { ReducerState } from "rootReducer";
import { FormRowGrid, GridRowProps } from "Quoting/components/shared/GridRow";
import { QuoteFormElement } from "Quoting/components/shared/QuoteFormElement";
import { FormWrapper } from "Quoting/components/shared/QuoteFormWrapper";
import { getGPLUEligibilityBlockPropertyPaths } from '../PropertyPaths';

export const EligibilityBlock  = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUEligibilityBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: { key: 'row-2764b5c4-cebe-4e64-8b36-eb437adde6a8' },
      title: 'ISSUE AGES',
      items: [
        {
          key: "b85be889-7005-46b6-9d1d-700dc74b9ac5",
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Issue Age (days)"
              id={propertyPaths.minIssueAge}
              value={getQuoteFieldValue(propertyPaths.minIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minIssueAge, Number(e.target.value))}
              type="number"
              required
              disabled
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        },
        {
          key: "7defe09e-b20c-4d5a-bade-66c4f3a25f49",
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Issue Through Age (years)"
              id={propertyPaths.maxIssueAge}
              value={getQuoteFieldValue(propertyPaths.maxIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.maxIssueAge, Number(e.target.value))}
              type="number"
              disabled
              required
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        }
      ]
    }
  ];

  return (
    <FormWrapper title="Eligibility" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
